export default function BaseDivider({ className = "" }) {
  return (
    <hr className={["border-t border-gray-100 dark:border-slate-700 my-3", className].join(" ")} />
  );
}
